module.exports = __webpack_public_path__ + "img/open-gray.356fe26b.png";